import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import Sponsors from "../components/Sponsors";

export default function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <Sponsors />
    </>
  );
}
